import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Кръгли чаршафи с ластик ранфорс 100% памук | Размери по поръчка | GoToBed',
  description:
    'Кръгли чаршафи с ластик от ранфорс 100% памук. Диаметри 200, 210, 220 см. Височина на матрака 10–50 см. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Кръгли чаршафи с ластик от ранфорс
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Кръгли чаршафи с ластик ранфорс от 100% памук – богат избор от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Кръглите чаршафи с ластик от ранфорс (100% памук) са практично решение за кръгъл матрак и
          се отличават със здравина, дишаща материя и комфорт при ежедневна употреба. Основното ни
          предимство е богатото разнообразие от размери, което улеснява избора за различни кръгли
          матраци. Предлагаме едноцветни модели и шарени десени с принт. Налични са размери с
          диаметър 200, 210 и 220 см, както и варианти за височина на матрака от 10 до 50 см.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyKrugliRanfors />;
}

function SeoBodyKrugliRanfors() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Кръгли чаршафи с ластик от ранфорс */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Кръгли чаршафи с ластик от ранфорс
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Кръглите чаршафи с ластик от ранфорс са практично и комфортно решение за легла с кръгъл
        матрак. Ранфорсът е висококачествен 100% памучен плат с класическо тъкане, който се отличава
        с добра плътност, издръжливост и приятна мекота. Ако имате кръгло легло, стандартните
        чаршафи трудно прилягат добре и често се свличат или набират по време на сън. Затова
        най-доброто решение е кръгъл чаршаф с ластик, изработен по точните размери на вашия матрак.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed изработваме кръгли чаршафи от ранфорс по индивидуални размери, така че да прилягат
        перфектно към матрака и да осигуряват максимален комфорт по време на сън. При поръчка можете
        да изберете както диаметъра, така и височината на матрака, за да получите чаршаф, който
        пасва идеално.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако искате да видите и други модели кръгли чаршафи, можете да разгледате:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/krugli-sharshafi-s-lastik/1/6"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          всички кръгли чаршафи с ластик
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/krugli-sharshafi-s-lastik/1/6/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          кръгли чаршафи с ластик памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери кръгли чаршафи с ластик от ранфорс за кръгъл матрак */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери кръгли чаршафи с ластик от ранфорс за кръгъл матрак
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме кръгли чаршафи с ластик от ранфорс за матраци с диаметър:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['кръгъл чаршаф 200 см', 'кръгъл чаршаф 210 см', 'кръгъл чаршаф 220 см'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите могат да бъдат изработени за матраци с височина:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['10–15 см', '16–20 см', '21–25 см', '26–30 см', '31–40 см', '41–50 см'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на ластика по целия ръб, чаршафът прилепва стабилно към матрака и остава на
          мястото си през цялата нощ.
        </Typography>

        {/* H2: Какво представлява платът ранфорс? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява платът ранфорс?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е висококачествен 100% памучен плат, който е много популярен за спално бельо и
          чаршафи. Той се отличава с добра плътност, здравина и приятна мекота на допир.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Основните предимства на ранфорса са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '&#10004; естествен 100% памук',
            '&#10004; отлична дишаемост и комфорт по време на сън',
            '&#10004; устойчивост при пране и дълготрайна употреба',
            '&#10004; мека и приятна на допир материя',
            '&#10004; подходящ за използване през всички сезони'
          ].map((item) => (
            <Typography
              key={item}
              variant="body1"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите и други продукти от същата материя, можете да разгледате:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi/1/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик ранфорс
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всички наши кръгли чаршафи от ранфорс се изработват от платове със сертификат OEKO-TEX
          Standard 100, което гарантира безопасност и високо качество на текстила.
        </Typography>

        {/* H2: Предимства на кръглите чаршафи с ластик от ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на кръглите чаршафи с ластик от ранфорс
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '&#10004; изработка по индивидуален размер',
            '&#10004; подходящи за кръгли матраци и кръгли легла',
            '&#10004; диаметри 200, 210 и 220 см',
            '&#10004; подходящи за матраци с височина 10–50 см',
            '&#10004; 100% памук ранфорс',
            '&#10004; OEKO-TEX Standard 100 сертификат на платовете',
            '&#10004; ластик по целия ръб за стабилно фиксиране',
            '&#10004; произведени в България'
          ].map((item) => (
            <Typography
              key={item}
              variant="body1"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всеки кръгъл чаршаф се изработва по поръчка, което гарантира точни размери и отлично
          прилягане към матрака.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да допълните комплекта спално бельо, можете да комбинирате чаршафа с:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници ранфорс
          </Typography>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Кръглите чаршафи с ластик от ранфорс се изработват индивидуално след направена поръчка.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          за около 4–7 работни дни.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          След изработката поръчката се изпраща с куриер до посочения от вас адрес или до офис на
          куриерската фирма.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за кръгли чаршафи с ластик от ранфорс
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представлява платът ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Ранфорсът е 100% памучен плат, който се отличава с добра плътност, здравина и отлична
            дишаемост. Той е много подходящ за спално бельо и чаршафи, защото осигурява комфорт по
            време на сън и издържа на многократно пране.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е ранфорсът за чаршафи с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Ранфорсът е отличен избор за чаршафи с ластик, защото е здрав, устойчив и приятен на
            допир. Материята запазва формата си дори след многократно пране и осигурява комфорт при
            ежедневна употреба.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За какви размери кръгли матраци са подходящи чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Нашите кръгли чаршафи от ранфорс са подходящи за матраци с диаметър 200 см, 210 см и 220
            см, както и за матраци с височина 10–50 см.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свлича ли се кръглият чаршаф с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Не. Ластикът е поставен по целия ръб на чаршафа, което позволява той да обхване стабилно
            матрака и да остане на мястото си по време на сън.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи с ластик от памук ранфорс се изработват в България, специално за всяка
            поръчка и според избраните размери на матрака.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
